import {Injector, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {EshopBtnComponent} from './eshop-btn';
import {createCustomElement} from "@angular/elements";
import {RouterLinkActive, RouterLinkWithHref} from '@angular/router';

@NgModule({
    declarations: [
        EshopBtnComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        RouterLinkActive,
        RouterLinkWithHref
    ],
    exports: [EshopBtnComponent]
})

export class EshopBtnModule {
    constructor(private injector: Injector) {
        const EshopBtn = createCustomElement(EshopBtnComponent, {injector});
        !customElements.get('ngx-eshop') && customElements.define('ngx-eshop', EshopBtn);
    }
}
